// import Banner from './Banner';
import React from 'react'
import { connect } from 'react-redux'
import {
  Card,
  Button,
  Row,
  Col,
  Radio,
  Tooltip,
  Badge,
  Alert,
  Space
} from 'antd'
import { Translation } from 'react-i18next'
import { format } from 'date-fns'
import { columnsLocal, APISearchResult, APISearchQuery } from '../../components/SearchResult/index'
import openNotification from '../../components/Notification/Notificaiton'
import agent from '../../agent'
import {
  API_BUILD_LOCAL_SEARCH,
  API_BUILD_LOCAL_RESET
} from './../../constants/actionTypes'
import I_18_N from '../../i18n';
import AlertBox from '../../components/AlertBox'



const mapStateToProps = state => ({
  apiBuilderLocal: state.apiBuilderLocal
})

const mapDispatchToProps = dispatch => ({
  getSearchResult: (pagination, query) =>
    dispatch({
      type: API_BUILD_LOCAL_SEARCH,
      payload: agent.ApiBuilder.localSearchResult(pagination, query)
    }),
  resetSearchResult: query =>
    dispatch({
      type: API_BUILD_LOCAL_RESET,
      payload: {}
    })
})


class SearchResult extends React.Component {
  constructor(props, t) {
    super(props)
    this.state = {
      btnSize: 'small',
      show: false,
      rulesData: { [new Date().getTime()]: { key1: "Brn", key2: "equal", key3: '' } },
      // rulesData: { [new Date().getTime()]: { key1: "Cr_no", key2: "equal", key3: '' } },
      handleChangeLang: 'en',
      alertHide: true
    }
  }

  handleClickReset = () => {
    // this.props.form.resetFields()
    this.setState({ rulesData: { [new Date().getTime()]: { key1: "Brn", key2: "equal", key3: '' } } })
    // this.setState({ rulesData: { [new Date().getTime()]: { key1: "Cr_no", key2: "equal", key3: '' } } })
    this.props.resetSearchResult()
  }

  getTableData = async (type, data) => {
    var params = {};
    var pagination = data;
    var tmpQuery = JSON.parse(JSON.stringify(Object.values(this.state.rulesData)));
    var query = [];
    await tmpQuery.map(q => {
      if (q.hasOwnProperty('key1') && q.hasOwnProperty('key2') && q.hasOwnProperty('key3')) {
        if (q['key1'] !== "empty" && q['key2'] && q['key3']) {
          query.push(q);
        }
      }
    });
    switch (type) {
      case 'default':
        params = pagination;
        break;
      case 'table_change':
        params = pagination;
        break;
      case 'clear':
        var { pageSize } = this.props.apiBuilderLocal.pagination;
        params = { current: 1, pageSize: pageSize };
        break;
      case 'search':
        var { pageSize } = this.props.apiBuilderLocal.pagination;
        params = { current: 1, pageSize: pageSize };
        break;
      default:
        break;
    }
    this.props.getSearchResult(params, query);
  }

  handleClickGetResult = async () => {
    var tmpRulesData = JSON.parse(JSON.stringify(this.state.rulesData));
    var tmpQueryKeys = JSON.parse(JSON.stringify(Object.keys(this.state.rulesData)));
    var tmpQuery = JSON.parse(JSON.stringify(Object.values(this.state.rulesData)));
    var error = [];
    await tmpQuery.map((q, i) => {
      if (q.hasOwnProperty('key1') && q.hasOwnProperty('key2') && q.hasOwnProperty('key3')) {
        if (q['key1'] !== "empty" && q['key2'] && q['key3']) {
        } else {
          error.push(tmpQueryKeys[i])
          console.log('akash query1', q, tmpQueryKeys[i])
        }
      } else {
        error.push(tmpQueryKeys[i])
        console.log('akash query2', q, tmpQueryKeys[i])
      }
    });
    console.log('akash query', tmpRulesData, error)
    if (error.length === 0) {
      this.getTableData('search')
    } else {
      await tmpQueryKeys.map(id => {
        if (error.indexOf(id) >= 0) {
          tmpRulesData[id]["error"] = true;
        } else {
          delete tmpRulesData[id]["error"];
        }
      });
      this.setState({ rulesData: tmpRulesData })
    }

  }
  handleTableChange = (pagination, filters, sorter) => {
    console.log('handleTableChange = (pagination', pagination)
    this.getTableData('table_change', {
      ...{ sortField: sorter.field },
      ...{ sortOrder: sorter.order },
      ...{ current: pagination.current },
      ...{ pageSize: pagination.pageSize },
      // ...filters,
    });
  };

  handleAddRule = () => {
    var tmpData = JSON.parse(JSON.stringify(this.state.rulesData))
    // tmpData[Object.keys(tmpData).length] = { key1: '', key2: '' }
    // tmpData[new Date().getTime()] = { key1: '', key2: '' }
    tmpData[new Date().getTime()] = { key1: 'empty' }
    // tmpData.push({ key1: '', key2: '' });
    this.setState({ rulesData: tmpData })
  }

  handleDeleteRule = index => {
    var tmpData = JSON.parse(JSON.stringify(this.state.rulesData))
    delete tmpData[index]
    // tmpData.splice(index, 1);
    this.setState({ rulesData: tmpData })
  }

  handleOnChange = (index, value, id) => {
    var tmpData = JSON.parse(JSON.stringify(this.state.rulesData))
    if (value === 'empty') {
      tmpData[index]['key1'] = value
      delete tmpData[index]['key2']
      delete tmpData[index]['key3']
    } else if (id === 'key_1') {
      console.log('key_1', value);
      tmpData[index]['key1'] = value
      tmpData[index]['key2'] = (value === "Comp_name" || value === "Corp_name_full") ? "begins_with" : "equal"
      tmpData[index]['key3'] = ''
    } else if (value === 'asc' || value === 'desc') {
      tmpData[index]['key2'] = value
      delete tmpData[index]['key3']
    } else if (id === 'key_2') {
      tmpData[index]['key2'] = value
      tmpData[index]['key3'] = ''
    } else if (id === 'key_3') {
      tmpData[index]['key3'] = value;// removing free spaces 
    }
    delete tmpData[index]["error"]
    this.setState({ rulesData: tmpData })
    console.log(tmpData)
  }

  handleChangeLang = e => {
    this.setState({
      handleChangeLang: e.target.value,
    })
  }


  componentDidMount() {
    // document.title = this.props.title;
    if (this.props.location.search.indexOf('?lang=') === 0) {
      var URL_LANG = this.props.location.search.split('?lang=')[1]
      if (['en', 'sc', 'tc'].indexOf(URL_LANG)) {
        I_18_N.changeLanguage(URL_LANG);
      }
    }

  }
  componentDidUpdate() {
    const TITLE = {
      en: 'Companies Registry - Registered Office Address of Live Local Companies',
      sc: '公司注册处 - 仍在登记册上的本地公司的注册办事处地址',
      tc: '公司註冊處 - 仍在登記冊上的本地公司的註冊辦事處地址',
    }
    const DOUBLE_RIGHT = {
      en: 'double-right',
      sc: '双右',
      tc: '雙右',
    }
    const DOUBLE_LEFT = {
      en: 'double-left',
      sc: '双左',
      tc: '雙左',
    }
    var URL_LANG = this.props.location.search.split('?lang=')[1]

    document.title = TITLE[URL_LANG] == undefined ? 'Companies Registry - Registered Office Address of Live Local Companies' : TITLE[URL_LANG];
    const labelAriaRight = document.getElementsByClassName('anticon-double-right')[0];
    const labelAriaLeft = document.getElementsByClassName('anticon-double-left')[0];
    // set attribute
    labelAriaRight !== undefined && labelAriaRight.setAttribute('aria-label', DOUBLE_RIGHT[URL_LANG]);
    labelAriaLeft !== undefined && labelAriaLeft.setAttribute('aria-label', DOUBLE_LEFT[URL_LANG]);
    
  }
  componentWillReceiveProps(nextProps) {
    console.log('componentWillReceiveProps', this.props)
    console.log("nextProps",nextProps)
    if (nextProps.apiBuilderLocal.actualTotal > nextProps.settingPaginationTotal && 
      nextProps.apiBuilderLocal.pagination.current == 1) {
        console.log("nextProps",nextProps)
    }
    window.addEventListener('keydown', e => {
      if (e.key === "Tab") {
        console.log(e.key, "Key")
        this.setState({
          alertHide: false
        })
      }
    });
  }

  render() {
    const { size, settingPaginationTotal } = this.props
    const { apiBuilderLocal } = this.props
    const img_lang = {
      en: './images/logo_en.svg',
      sc: './images/logo_cn.png',
      tc: './images/logo_zh.png',
    }
    const data = []
    for (let i = 0; i < settingPaginationTotal; i++) {
      data.push({
        key: i + 1,
        hash: i + 1,
        Brn: `2135${i}`,
        name_reg_chinese: `名字 _${i}`,
        name_reg_eng: `Name_${i}`,
        address: `3${i} South Honey Creek St. Attleboro, MA 0270${i}`,
        company_type: `Company Type${i}`,
        date_of_incorporation: `06-08-2021`
      })
    }

    return (
      <Translation>
        {(t, { i18n }) => (

          <div className='height_100 seachResultTable apiBuilderContainer'>
            <Alert type="error" role='error' style={{ marginTop: 15, display: this.state.alertHide ? "none" : "flex" }}
              action={
                <Button type="danger" onBlur={() => this.setState({ alertHide: true })} onClick={() => this.setState({ alertHide: true })}>
                  Skip to main content
                </Button>
              }
            ></Alert>
            <Row align='middle' justify='space-between'>
              <Col>
                <a href='https://www.cr.gov.hk' target='_blank'>
                  <img
                    src={img_lang[i18n.language]}
                    // alt='Companies Registry Logo Image'
                    alt={t('ALT_TEXT_LOGO')}
                    style={{
                      height: '40px',
                      margin: '15px',
                      maxWidth: 'calc(100% - 30px)'
                    }}
                  />
                </a>
              </Col>
              <Col align='right' style={{ padding: '15px' }}>
                <Space size={2}>
                  {[
                    { name: 'English', value: 'en' },
                    { name: '简体版', value: 'sc' },
                    { name: '繁體版', value: 'tc' }
                  ].map(d => {
                    // if (d.value !== i18n.language) {
                    return (
                      <Tooltip placement='bottom' title={d.name} key={d.value}>
                        <Button size='small' type={d.value === i18n.language && 'primary'} value={d.value} onClick={e => {
                          this.props.history.push(this.props.location.pathname + '?lang=' + d.value);
                          i18n.changeLanguage(d.value)
                        }}>{d.name}</Button>
                      </Tooltip>
                    )
                    // }
                  })}
                </Space>
                {/* <Radio.Group
                  size='small'
                  value={i18n.language}
                  onChange={e => {
                    this.props.history.push(this.props.location.pathname + '?lang=' + e.target.value);
                    i18n.changeLanguage(e.target.value)
                  }}
                >
                  {[
                    { name: 'English', value: 'en' },
                    { name: '简体版', value: 'sc' },
                    { name: '繁體版', value: 'tc' }
                  ].map(d => {
                    if (d.value !== i18n.language) {
                      return (
                        <Tooltip placement='bottom' title={d.name} key={d.value}>
                          <Radio.Button value={d.value}>{d.name}</Radio.Button>
                        </Tooltip>
                      )
                    }
                  })}
                </Radio.Group> */}
              </Col>
            </Row>
            <Card
              size={this.state.btnSize}
              style={{ height: 'calc(100% - 80px)' }}
              title={
                <h1>
                  {t(
                    'API_BUILDER_TITLE_LOCAL'
                  )}
                </h1>
              }
              // title="Registered Office Addresses and Principal Places of Business API Builder"
              bordered={false}
            >
              <Badge count={'JSON'} style={{ backgroundColor: '#EB1000' }} />
              <ul className='apiBuilderUl'>
                <li>
                  {t('API_FOR_DATA_FILTERING')}
                  {/* API for data filtering */}
                </li>
              </ul>
              <APISearchQuery t={t} data={this.state.rulesData} isLocal={true}
                handleAddRule={this.handleAddRule}
                handleOnChange={this.handleOnChange}
                handleDeleteRule={this.handleDeleteRule}
                handleClickReset={this.handleClickReset}
                handleClickGetResult={this.handleClickGetResult}
                I_18_N={I_18_N}
              />
              {apiBuilderLocal.data && (
                <APISearchResult
                  t={t}
                  size={size}
                  data={apiBuilderLocal.data}
                  dataApi={apiBuilderLocal.dataApi}
                  columns={columnsLocal(t)}
                  pagination={apiBuilderLocal.pagination}
                  handleTableChange={this.handleTableChange}
                  handleChangeLang={i18n.language}
                  settingPaginationTotal={settingPaginationTotal}
                />
              )}
            </Card>
            <Row align='middle' justify='space-between'>
              <Col>
                {[
                  { name: 'https://www.cr.gov.hk/en/footer/notices/index.htm', value: 'en' },
                  { name: 'https://www.cr.gov.hk/sc/footer/notices/index.htm', value: 'sc' },
                  { name: 'https://www.cr.gov.hk/tc/footer/notices/index.htm', value: 'tc' }
                ].map(d => {
                  if (d.value == i18n.language) {
                    return (
                      <a href={d.name} target='_blank'>
                        {t('IMPORTANT_NOTICE')}
                      </a>
                    )
                  }
                })}
                <span> | </span>
                {[
                  { name: 'https://www.cr.gov.hk/en/footer/privacy/index.htm', value: 'en' },
                  { name: 'https://www.cr.gov.hk/sc/footer/privacy/index.htm', value: 'sc' },
                  { name: 'https://www.cr.gov.hk/tc/footer/privacy/index.htm', value: 'tc' }
                ].map(d => {
                  if (d.value == i18n.language) {
                    return (
                      <a href={d.name} target='_blank'>
                        {t('PRIVACY_POLICY')}
                      </a>
                    )
                  }
                })}
              </Col>
              <Col align='right'>
                <a href='https://www.w3.org/WAI/WCAG2AA-Conformance' target='_blank'>
                  <img
                    src='./images/wcag2.1AA-v.png'
                    alt={t('ALT_TEXT_W3C')}
                    style={{
                      height: '40px',
                      margin: '10px',
                      maxWidth: 'calc(100% - 30px)'
                    }}
                  />
                </a>
              </Col>
            </Row>
            <Row>
              <Col>
                {[
                  { name: format(new Date(process.env.REACT_APP_REVISION_DATE), 'dd MMMM yyyy').toString(), value: 'en' },
                  { name: format(new Date(process.env.REACT_APP_REVISION_DATE), 'yyyy年MM月dd日').toString(), value: 'sc' },
                  { name: format(new Date(process.env.REACT_APP_REVISION_DATE), 'yyyy年MM月dd日').toString(), value: 'tc' }
                ].map(d => {
                  if (d.value == i18n.language) {
                    return (
                      t('COPYRIGHT_REVISION', { year: new Date().getFullYear(), re_date: d.name })
                    )
                  }
                })}
              </Col>
              <AlertBox 
                apiBuilderLocal={this.props.apiBuilderLocal || {}} 
                settingPaginationTotal={this.props.settingPaginationTotal|| 0}
                />
            </Row>
          </div>
        )}
       
      </Translation>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchResult)



// WEBPACK FOOTER //
// src/layouts/views/searchResult.js